import React, { useContext } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { Field, ErrorMessage } from "formik";
import FormError from "../../FormError";
import FMUSelectField from "../../shared/FormIkMUFormComponent/FMUSelect";
import { viewportContext } from "../../../context/ViewportContext";

import { useCaseStyles } from "../useCaseStyle";

interface NewCaseSelectProps {
  label: string;
  name: string;
  type?: string;
  options: string[] | { label: string; value: string }[];
  required?: boolean;
}

const useStyles = makeStyles(() => ({
  parentChild: {
    flex: "1",
    width: "100%",
    minWidth: 0,
  },
  parentChildTallScreen: {
    flex: "1",
    width: "100%",
    minWidth: 0,
  },
}));

const NewCaseSelect: React.FC<NewCaseSelectProps> = ({
  label,
  name,
  type = "text",
  options,
  required = false,
}) => {
  const classes = useStyles();
  const useCaseClasses = useCaseStyles();
  const { tallScreen } = useContext(viewportContext) as {
    tallScreen?: boolean;
  };

  return (
    <div
      className={
        tallScreen ? classes.parentChildTallScreen : classes.parentChild
      }
    >
      <div className={useCaseClasses.rowContainer}>
        <div className={useCaseClasses.labelContainer}>
          <Typography>
            {label}
            {required && <span className={useCaseClasses.astrike}>*</span>}
          </Typography>
        </div>
        <div className={useCaseClasses.fieldContainer}>
          <Field
            name={name}
            type={type}
            options={options}
            fullWidth
            disableUnderline
            className={useCaseClasses.input}
            component={FMUSelectField}
          />
          <ErrorMessage
            name={name}
            component={FormError}
            className={useCaseClasses.error}
          />
        </div>
      </div>
    </div>
  );
};

export default NewCaseSelect;
